// extracted by mini-css-extract-plugin
export var createdDate = "_jm-1";
export var divider = "_jm-2";
export var headerDivider = "_jm-3";
export var messagesCard = "_jm-0";
export var messagesContainer = "_jm-6";
export var messagesContainerWrapper = "_jm-4";
export var showLeftPanelButton = "_jm-8";
export var topButtons = "_jm-7";
export var withPadding = "_jm-5";